<template>
  <div class="content-block">
    <div class="data-block">
      <div
        class="preview-block short"
        v-loading="load"
      >
        <Invoice v-if="!notfound && this.bill.hash.length == 6" :data="bill"/>
        <Act v-if="!notfound && this.bill.hash.length == 7" :data="bill" />
        
        <div class="bill-actions">
            <div class="action-one preview" v-if="!notfound">
                <a class="button btn-light" 
                    @click="print">
                <div
                    class="button-icon"
                    v-html="$root.icons.print"
                ></div>
               Распечатать</a>
            </div>
           
          <div class="action-one" v-if="!notfound">
            <a class="button btn-dark" @click="get('pdf')">
              <div class="button-content" v-if="!load_pdf">
                <div class="button-icon" v-html="$root.icons.download"></div>
                Pdf
              </div>
              <el-progress
                v-if="load_pdf"
                :percentage="progress_pdf"
              ></el-progress
            ></a>
          </div>
            <div class="action-one preview" v-if="notfound">
                <router-link
                    class="button"
                    :to="'/'"
                >
                <div
                    class="button-icon"
                    v-html="$root.icons.home"
                ></div>
               На главную</router-link>
            </div>


        </div>
        

        <div class="not-found" v-if="notfound">
            <div class="not-found-smile">
         <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 512 512" xml:space="preserve"><path d="M401.032,432.147c-28.763,0-48.014-23.595-64.148-43.368l-1.42-1.739  c-4.957-6.069-4.057-15.007,2.012-19.965s15.007-4.056,19.966,2.011l1.429,1.752c23.009,28.197,34.53,38.775,56.124,29.678  c12.53-5.277,16.067-17.365,20.799-36.652c4.465-18.191,9.524-38.809,28.598-51.021c6.601-4.226,15.375-2.301,19.601,4.298  c4.226,6.6,2.3,15.375-4.299,19.601c-9.519,6.095-12.68,18.974-16.339,33.886c-4.916,20.031-11.034,44.959-37.344,56.042  C416.939,430.491,408.651,432.147,401.032,432.147z" style="fill: rgb(237 227 213);"></path><path d="M483.994,317.142c-4.226-6.599-13-8.524-19.601-4.298c-4.819,3.085-8.74,6.708-11.987,10.692  c3.28,7.479,9.742,16.5,20.448,20.132c1.86-2.798,4.076-5.155,6.84-6.925C486.294,332.517,488.219,323.742,483.994,317.142z" style="fill: rgb(231 215 186);"></path><g><path d="M336.38,512c-11.666,0-21.586-8.939-22.595-20.776c-3.019-35.418-1.185-61.432,5.947-84.35   c3.725-11.973,16.452-18.66,28.423-14.932c11.972,3.725,18.658,16.451,14.932,28.423c-5.304,17.048-6.557,37.712-4.061,67.003   c1.065,12.493-8.2,23.484-20.693,24.549C337.678,511.973,337.026,512,336.38,512z" style="fill: rgb(237 227 213);"></path><path d="M265.521,512c-11.667,0-21.586-8.939-22.595-20.777c-3.018-35.42-1.184-61.435,5.947-84.349   c3.725-11.973,16.452-18.66,28.423-14.932c11.972,3.725,18.658,16.451,14.932,28.423c-5.304,17.045-6.556,37.71-4.061,67.004   c1.064,12.493-8.2,23.484-20.693,24.548C266.819,511.973,266.166,512,265.521,512z" style="fill: rgb(237 227 213);"></path><path d="M162.636,381.954c-21.202,0-40.51-7.642-54.418-21.549c-8.865-8.866-8.865-23.24,0-32.106   c8.866-8.866,23.242-8.866,32.108,0c6.798,6.798,15.834,8.25,22.308,8.25c0.082,0,0.164,0,0.246-0.001   c13.112-0.075,27.205-5.873,35.904-14.772c8.766-8.967,23.141-9.129,32.104-0.365c8.966,8.765,9.13,23.138,0.365,32.104   c-17.008,17.399-43.109,28.295-68.116,28.437C162.971,381.953,162.804,381.954,162.636,381.954z" style="fill: rgb(237 227 213);"></path></g><g><path d="M408.18,402.8c-17.461,4.245-28.844-6.882-49.309-31.962   l-1.429-1.752c-4.958-6.068-13.897-6.97-19.966-2.011c-6.069,4.958-6.97,13.897-2.012,19.965l1.42,1.739   c13.465,16.503,29.107,35.657,50.634,41.544C395.728,422.165,402.71,412.903,408.18,402.8z" style="opacity: 0.2; fill: rgb(163, 95, 0);"></path><path d="M348.154,391.942c-11.971-3.728-24.698,2.959-28.423,14.932   c-5.336,17.144-7.704,36.023-7.296,59.273c16.378-1.914,31.777-6.829,45.562-14.136c0.546-12.13,2.219-22.426,5.089-31.647   C366.812,408.393,360.127,395.667,348.154,391.942z" style="opacity: 0.2; fill: rgb(163, 95, 0);"></path><path d="M277.296,391.942c-11.971-3.728-24.698,2.959-28.423,14.932   c-4.442,14.275-6.827,29.756-7.266,47.961c13.872,6.492,29.2,10.628,45.392,11.838c-0.43-18.841,1.269-33.585,5.228-46.309   C295.954,408.393,289.268,395.667,277.296,391.942z" style="opacity: 0.2; fill: rgb(163, 95, 0);"></path><path d="M198.785,321.775c-6.438,6.585-15.829,11.464-25.59,13.591   c-0.615,4.714-0.938,9.512-0.938,14.38c0,10.764,1.557,21.19,4.457,31.099c20.549-3.182,40.599-13.07,54.54-27.331   c8.765-8.966,8.601-23.34-0.365-32.104C221.925,312.646,207.551,312.808,198.785,321.775z" style="opacity: 0.2; fill: rgb(163, 95, 0);"></path></g><ellipse cx="296.97" cy="349.75" rx="104.71" ry="97.3" style="fill: #f5f5f5;"></ellipse><path d="M281.679,446.013  c-47.851-31.416-33.021-95.805-24.898-123.964v-62.175c-37.885,14.645-64.524,49.366-64.524,89.872  C192.257,398.658,231.096,439.135,281.679,446.013z" style="opacity: 0.15; fill: rgb(193, 122, 0);"></path><path d="M233.245,181.025c20.49-17.193,34.171-46.056,5.269-88.722  C209.385,49.3,166.016,38.52,132.157,42.509c-8.347,0.983-15.351,6.86-17.769,14.91c-9.808,32.652-6.723,77.234,30.569,113.389  C181.956,206.679,212.755,198.219,233.245,181.025z" style="fill: rgb(231 215 186);"></path><path d="M113.025,62.416c-8.041,32.104-3.494,74.047,31.931,108.392c32.07,31.092,59.476,28.87,79.554,16.533  C210.702,93.6,150.38,68.742,113.025,62.416z" style="fill: rgb(255, 145, 171);"></path><path d="M360.694,181.025c-20.49-17.193-34.171-46.056-5.269-88.722  c29.13-43.004,72.499-53.783,106.358-49.794c8.348,0.983,15.352,6.86,17.77,14.91c9.808,32.652,6.723,77.234-30.569,113.389  C411.984,206.679,381.184,198.219,360.694,181.025z" style="fill: rgb(231 215 186);"></path><path d="M480.915,62.416c8.041,32.104,3.494,74.047-31.931,108.392c-32.07,31.092-59.476,28.87-79.555,16.533  C383.238,93.6,443.559,68.742,480.915,62.416z" style="fill: rgb(255, 145, 171);"></path><path d="M475.243,206.975c0,81.511-79.815,117.212-178.273,117.212c-98.457,0-178.273-35.701-178.273-117.212  S198.513,59.386,296.97,59.386S475.243,125.464,475.243,206.975z" style="fill: #f5f5f5;"></path><path d="M201.781,82.173c-49.927,26.155-83.084,72.27-83.084,124.802  c0,70.07,58.981,106.286,138.083,115.074C143.232,254.223,158.041,162.991,201.781,82.173z" style="opacity: 0.15; fill: rgb(193, 122, 0);"></path><g><ellipse cx="188.6" cy="210.41" rx="32.28" ry="25.705" style="fill: rgb(255, 145, 171);"></ellipse><ellipse cx="363.56" cy="210.41" rx="32.28" ry="25.705" style="fill: rgb(255, 145, 171);"></ellipse></g><g><path d="M207.408,192.271c-4.143,0-7.5-3.358-7.5-7.5v-11.399c0-4.142,3.357-7.5,7.5-7.5s7.5,3.358,7.5,7.5   v11.399C214.908,188.913,211.551,192.271,207.408,192.271z" style="fill: rgb(73, 80, 89);"></path><path d="M344.744,192.271c-4.142,0-7.5-3.358-7.5-7.5v-11.399c0-4.142,3.358-7.5,7.5-7.5   c4.143,0,7.5,3.358,7.5,7.5v11.399C352.244,188.913,348.887,192.271,344.744,192.271z" style="fill: rgb(73, 80, 89);"></path><path d="M143.081,214.918c-3.36,0-6.418-2.275-7.271-5.683c-1.004-4.019,1.439-8.091,5.457-9.095   c8.914-2.229,30.156-3.814,40.503-2.449c4.106,0.543,6.996,4.312,6.453,8.419c-0.544,4.107-4.327,6.996-8.418,6.453   c-8.168-1.081-27.774,0.348-34.899,2.129C144.296,214.845,143.684,214.918,143.081,214.918z" style="fill: rgb(73, 80, 89);"></path><path d="M153.362,253.164c-2.3,0-4.569-1.054-6.04-3.047c-2.46-3.332-1.752-8.028,1.58-10.488   c7.393-5.455,26.428-15.017,36.515-17.695c4.006-1.063,8.11,1.321,9.174,5.324c1.063,4.003-1.32,8.11-5.324,9.174   c-7.962,2.114-25.546,10.904-31.456,15.267C156.47,252.687,154.909,253.164,153.362,253.164z" style="fill: rgb(73, 80, 89);"></path><path d="M409.071,214.918c-0.603,0-1.214-0.073-1.825-0.226c-7.125-1.782-26.732-3.208-34.899-2.129   c-4.088,0.542-7.874-2.345-8.418-6.453c-0.543-4.106,2.347-7.875,6.453-8.418c10.346-1.368,31.589,0.22,40.503,2.449   c4.018,1.004,6.461,5.077,5.457,9.095C415.489,212.643,412.432,214.918,409.071,214.918z" style="fill: rgb(73, 80, 89);"></path><path d="M398.79,253.164c-1.548,0-3.107-0.477-4.448-1.466c-5.909-4.362-23.493-13.152-31.456-15.267   c-4.003-1.063-6.387-5.17-5.324-9.174s5.169-6.385,9.174-5.324c10.088,2.679,29.123,12.24,36.515,17.696   c3.333,2.46,4.04,7.156,1.58,10.488C403.359,252.109,401.09,253.164,398.79,253.164z" style="fill: rgb(73, 80, 89);"></path></g><path d="M383.452,118.772H210.488c-19.002,0-32.833-18.023-27.917-36.377l4.357-16.268  C197.374,27.123,232.717,0,273.095,0h47.749c40.379,0,75.722,27.123,86.168,66.127l4.357,16.268  C416.285,100.75,402.454,118.772,383.452,118.772z" style="fill: rgb(3 104 250);"></path><path d="M257.757,1.331c-33.746,5.877-61.731,30.826-70.829,64.796l-4.357,16.268  c-4.916,18.355,8.915,36.377,27.917,36.377h48.151C243.543,100.571,248.172,26.394,257.757,1.331z" style="opacity: 0.1;"></path><path d="M341.92,118.772H210.488l6.659,14.367c7.096,15.31,22.435,25.108,39.31,25.108h39.495  c16.875,0,32.214-9.798,39.31-25.108L341.92,118.772z" style="fill: rgb(3 104 250);"></path><path d="M341.92,118.772H210.488l6.659,14.367  c7.096,15.31,22.435,25.108,39.31,25.108h39.495c16.875,0,32.214-9.798,39.31-25.108L341.92,118.772z" style="opacity: 0.1;"></path><path d="M411.369,82.395l-2.519-9.406h-46.681V45.784h36.602  c-3.001-5.387-6.528-10.408-10.51-15h-26.092V10.162c-4.777-2.5-9.793-4.576-15-6.185v26.806H304.47V0h-15v30.784h-42.7V3.978  c-5.206,1.609-10.223,3.685-15,6.185v20.621h-26.092c-3.982,4.592-7.509,9.613-10.51,15h36.602v27.205h-46.68l-2.519,9.406  c-0.502,1.875-0.799,3.745-0.924,5.594h50.124v30.784h15V87.989h42.699v30.784h15V87.989h42.699v30.784h15V87.989h50.124  C412.167,86.14,411.871,84.27,411.369,82.395z M289.47,72.989h-42.7V45.784h42.699v27.205H289.47z M347.169,72.989H304.47V45.784  h42.699V72.989z" style="opacity: 0.1;"></path><path d="M111.655,321.262l-11.681,2.475c-4.954,1.049-9.82-2.116-10.87-7.069l-2.133-10.071  c-1.435-6.773-8.089-11.101-14.862-9.666l-36.403,7.711c-6.773,1.435-11.101,8.089-9.666,14.862l2.699,12.743  c3.943,18.615,22.231,30.509,40.847,26.566l49.267-10.437c9.683-2.051,18.487-7.065,25.191-14.347l0,0  c6.41-6.963,9.053-16.599,7.092-25.858l-0.199-0.938c-1.425-6.728-9.798-9.117-14.559-4.155l-9.124,9.51  C123.042,316.98,117.607,320.002,111.655,321.262z" style="fill: rgb(183, 120, 102);"></path><path d="M46.095,302.441l-10.389,2.201c-6.773,1.435-11.101,8.089-9.666,14.862  l2.699,12.743c3.943,18.615,22.231,30.509,40.846,26.566l20.663-4.377C62.666,349.292,49.326,321.372,46.095,302.441z" style="opacity: 0.1;"></path><g><path d="M297.387,205.033c-1.764,0-3.533-0.618-4.959-1.877c-1.815-1.602-11.526-9.541-24.055-8.501   c-2.922,0.241-5.291,1.711-6.671,4.137c-2.048,3.6-6.626,4.859-10.227,2.812c-3.601-2.048-4.859-6.627-2.812-10.227   c3.848-6.765,10.581-11.019,18.474-11.671c18.159-1.498,31.541,8.961,35.215,12.203c3.106,2.741,3.402,7.48,0.662,10.586   C301.531,204.175,299.464,205.033,297.387,205.033z" style="fill: rgb(73, 80, 89);"></path><path d="M215.995,174.832c-0.355,0-0.715-0.025-1.077-0.077l-17.154-2.466   c-4.1-0.589-6.945-4.391-6.356-8.491c0.59-4.101,4.388-6.942,8.491-6.357l17.154,2.466c4.1,0.589,6.945,4.391,6.357,8.491   C222.872,172.136,219.664,174.832,215.995,174.832z" style="fill: rgb(73, 80, 89);"></path><path d="M336.157,174.832c-3.669,0-6.877-2.695-7.414-6.434c-0.589-4.1,2.257-7.901,6.356-8.491   l17.155-2.466c4.104-0.589,7.901,2.256,8.491,6.357c0.589,4.1-2.257,7.901-6.357,8.491l-17.155,2.466   C336.872,174.806,336.513,174.832,336.157,174.832z" style="fill: rgb(73, 80, 89);"></path></g><path d="M342.788,377.967c-15.327,0-30.173-4.457-43.578-13.299c-24.065-15.874-40.234-44.141-40.234-70.339  c0-12.539,10.164-22.703,22.703-22.703s22.703,10.164,22.703,22.703c0,9.515,7.417,24.249,19.831,32.436  c10.459,6.899,22.271,7.608,35.112,2.11c11.527-4.934,24.871,0.408,29.806,11.933c4.935,11.527-0.408,24.871-11.935,29.806  C365.728,375.527,354.126,377.967,342.788,377.967z" style="fill: rgb(237 227 213);"></path><path d="M342.788,377.967c-15.327,0-30.173-4.457-43.578-13.299  c-24.065-15.874-40.234-44.141-40.234-70.339c0-12.539,10.164-22.703,22.703-22.703s22.703,10.164,22.703,22.703  c0,9.515,7.417,24.249,19.831,32.436c10.459,6.899,22.271,7.608,35.112,2.11c11.527-4.934,24.871,0.408,29.806,11.933  c4.935,11.527-0.408,24.871-11.935,29.806C365.728,375.527,354.126,377.967,342.788,377.967z" style="opacity: 0.15; fill: rgb(193, 143, 0);"></path></svg>
            </div>

            <h2>Документ не найден</h2>
        </div>
      </div>

     
    </div>
    </div>
  </div>
</template>

<script>
import Invoice from "../bl-invoice.vue";
import Act from "../bl-invoice-act.vue";
import axios from "axios";

export default {
  name: "Bills",
  data: () => {
    return {
      load: false,
      bill: {},
      notfound: false,
      load_pdf: false,
      progress_pdf: 0,
      int_pdf: 0,
    };
  },
  components: {
    Invoice,
    Act
  },
  methods: {
    get(type) {
      this["load_" + type] = true;
      this["progress_" + type] = 0;

      this["int_" + type] = setInterval(() => {
        this["progress_" + type] += 1;

        if (this["progress_" + type] >= 100) {
          clearInterval(this.int);
        }
      }, 187.5);

      axios
        .get(this.$root.app.way + "/ajax/", {
          params: {
            action: "get-file-share",
            type: type,
            hash:  this.bill.hash,
          },
          responseType: "blob",
        })
        .then((response) => {
          clearInterval(this["int_" + type]);
          this["int_" + type] = setInterval(() => {
            this["progress_" + type] += 1;
            if (this["progress_" + type] >= 100) {
              clearInterval(this["int_" + type]);
              setTimeout(() => {
                this["load_" + type] = false;
                //window.location = response.data.link;
                var a = document.createElement("a");
                var url = window.URL.createObjectURL(new Blob([response.data]));
                a.href = url;
                a.download =
                  ( this.bill.hash.length == 6 ? 'Счет' : 'Акт') +
                  " №" + this.bill.name + " от " +  this.bill.date + ".pdf";
                document.body.append(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
              }, 250);
            }
          }, 10);
        })
        .catch(() => {
          this["load_" + type] = false;
          this.$message({
            message: "Произошла ошибка, попробуйте еще раз позже!",
            type: "error",
          });
        });
    },
    print(){
      window.print();
    },
  },
  created(){
      axios
        .post(this.$root.app.way + "/ajax/", {
          action: "get-share",
          hash: this.$route.params.bid
        })
        .then((response) => {
          clearInterval(this.int);
          if(response.data.result == 'false'){
              this.notfound = true;
          }else{
            this.bill = response.data ? response.data.bills : [];
          }
          this.int = setInterval(() => {
            this.progres += 1;
            if (this.progres == 100) {
              clearInterval(this.int);
              setTimeout(() => {
                this.ready = true;
              }, 250);
            }
          }, 10);
        });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.preview-block {
    display: flex;
    min-height: 962px;
    width: 840px;
    /* margin-left: 32px; */
    background-color: #FFF;
    border-radius: 4px;
    box-shadow: 6px 0 18px rgba(0, 0, 0, 0.06);
    margin-top: -120px;
    position: relative;
    z-index: 10;
    transition: 0.25s;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: stretch;
    align-content: stretch;
    position: relative; 
    &.short {
    width: 680px;
    }
}
.data-block{
    position: relative;
}
#app .preview-block > .bill-actions{
    left: 680px;
    top: 16px;
}
.not-found {
    padding: 48px;
    height: 100%;
    width:100%;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    align-content: stretch;
}

.not-found h2 {
    margin: 48px 0 0;
}

.not-found-smile {
    height: 200px;
    width: 200px;
}
.action-one.preview {
    margin-bottom: 40px;
}
.button-content {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    align-content: stretch;
}
</style>
